export const API_HOST = (() => {
  if (['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname)) {
    return '/console';
  }

  if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    // 165
    //return 'http://172.104.117.165:8888/console'
    // UAT
    // return 'https://testwww.uni-prosperity.com.tw/console';
    // 正式
    return 'https://www.uni-prosperity.com.tw/console';
    //0602測試站
    // return 'https://cec.syscom.tw/console'
  } else {
    // OCA
    if (window.location.host === 'www.uni-prosperity.com.tw:4466')
      return 'https://www.uni-prosperity.com.tw:4466/console';
    if (window.location.host === 'cec.syscom.tw')
      return 'https://cec.syscom.tw/console';
    if (window.location.host === 'www.uni-prosperity.com.tw')
      return 'https://www.uni-prosperity.com.tw/console';
    if (window.location.host === 'testweb.uni-prosperity.com.tw')
      return 'https://testweb.uni-prosperity.com.tw/console';
    if (window.location.host === 'testwww.uni-prosperity.com.tw')
      return 'https://testwww.uni-prosperity.com.tw/console';
  }
})();

// 第三方平台代登入
export const EC_LOGIN_ENDPOINT = (() => {
  if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    return 'https://ppr-online.uni-prosperity.com.tw:22443/account/eclogin';
  } else {
    if (window.location.host === 'testwww.uni-prosperity.com.tw') {
      return 'https://qa-online.uni-prosperity.com.tw/zh/account/login/';
    } else {
      return 'http://online.uni-prosperity.com.tw/zh/account/login/'
    }
  }
})();

// OMS API＿Host
export const APIGEE_API_HOST = (() => {
  if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    return 'https://34.117.240.106.nip.io';
  } else {
    if (window.location.host === 'testwww.uni-prosperity.com.tw') {
      return 'https://34.117.240.106.nip.io';
    } else {
      return 'https://34.36.14.78.nip.io';
    }
  }
})();

// OMS token
//測試站token
//Bearer DEF6082C-03A0-4D01-813B-D3170C63FB5B
//正式站token
//Bearer C0BC18B4-69A6-40D4-9175-EFDC0FFD9249

export const OMS_API_TOKEN = (() => {
  if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    return 'Bearer DEF6082C-03A0-4D01-813B-D3170C63FB5B';
  } else {
    if (window.location.host === 'testwww.uni-prosperity.com.tw') {
      return 'Bearer DEF6082C-03A0-4D01-813B-D3170C63FB5B';
    } else {
      return 'Bearer C0BC18B4-69A6-40D4-9175-EFDC0FFD9249';
    }
  }
})();

export const DEBUG_MODE = false;

export const USE_LOCAL_CONFIG = false;

export const GOOGLE_MAP_KEY = 'AIzaSyAGJXA9bPDoLXoidGF0Uq_h3cvIlYc1gXw'

var LINK = '';
if (window.location.host == 'cec.syscom.tw') {
  LINK = `https://toaccount.uni-prosperity.com.tw/C4TDMC/oauth/v2/authorization?response_type=code&client_id=b8f848827a0667870c436cca772b66a6&redirect_uri=https://cec.syscom.tw/service/sso/&state=C4&scope=read&device=1`;
} else LINK = `https://oca.uni-prosperity.com.tw/signin`;
export const LOGIN_LINK = LINK;

var ECLINK = '';
if (window.location.host == 'cec.syscom.tw') {
  ECLINK = `https://ppr-online.uni-prosperity.com.tw:22443/account/eclogin`
} else ECLINK = `http://online.uni-prosperity.com.tw/account/eclogin`
export const LOGIN_ECLINK = ECLINK;

export const ENTERTAIN_LINK = 'https://www.uni-prosperity.com.tw/公平待客/';



// WEBPACK FOOTER //
// ./src/configs/env.js